let widgetId = null;

function initHCaptchaOverlay() {
    const overlay = document.getElementById('captcha-overlay');
    if (!overlay) return;
    document.body.style.overflow = 'hidden';
}

function initHCaptcha() {
    const container = document.getElementById('hcaptcha');
    if (!container) return;

    const sitekey = container.dataset.sitekey;
    widgetId = window.hcaptcha.render('hcaptcha', {
        sitekey,
        size: 'normal',
        callback: onCaptchaSuccess,
        'error-callback': onCaptchaError,
        'expired-callback': onCaptchaExpired,
    });
}

function onCaptchaSuccess(token) {
    const formData = new FormData();
    formData.append('text', token);
    formData.append('state', 'some_state_value');

    fetch('/captcha/verify/web', {
        method: 'POST',
        body: formData,
    })
        .then(async response => {
            const text = await response.text();

            if (!response.ok) {
                throw new Error(text || 'Verification failed');
            }

            const trimmed = (text || '').trim();
            if (trimmed) {
                const error_container = document.getElementById('captcha-error-container');
                if (error_container) error_container.innerHTML = trimmed;
                if (typeof hcaptcha !== 'undefined' && widgetId !== null) {
                    try {
                        window.hcaptcha.reset(widgetId);
                    } catch (e) {
                        /* empty */
                    }
                }
            } else {
                closeCaptchaModal();
            }
        })
        .catch(onCaptchaError);
}

function onCaptchaError(err) {
    const error_container = document.getElementById('captcha-error-container');
    if (error_container) error_container.innerHTML = '<div>Ошибка при решении капчи. Попробуйте снова.</div>';
    console.error('hCaptcha error:', err);
    if (window.sendLog) {
        window.sendLog({
            event_name: 'browser_log',
            event_category: 'error',
            event_action: 'hcaptcha_error',
            event_label: 'Ошибка hCaptcha',
            event_params: {
                error_message: err?.message || String(err),
                url: window.location.href,
            },
        });
    }
}

function onCaptchaExpired() {
    const error_container = document.getElementById('captcha-error-container');
    if (error_container) error_container.innerHTML = '<div>Время капчи истекло. Попробуйте снова.</div>';
}

function closeCaptchaModal() {
    document.body.style.overflow = '';
    const overlay = document.getElementById('captcha-overlay');
    if (overlay) overlay.remove();
}

document.addEventListener('click', event => {
    if (event.target.id === 'close-captcha-button') {
        closeCaptchaModal();
    }
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHCaptchaOverlay);
} else {
    initHCaptchaOverlay();
}

window.initHCaptcha = initHCaptcha;
